
import React from 'react'

import MenuItem from './MenuItem'

const MenuDesktop = ({ collapsed, menuItems }) => (
  <div
    className='menu hidden-mobile flex-column'
    style={{
      height: '100vh',
      width: collapsed ? '60px' : '300px'
    }}
  >
    <div className='flex-row header j-ctn-c ai-ctr'>
      <img src='/assets/interneo_picto.svg' alt='Interneo logo' style={{ margin: '0px 12px' }} />
      {collapsed ? null : <span className='title'>Interneo</span>}
    </div>
    <div className='flex-column flex-fill' style={{ fontSize: '16px' }}>
      {menuItems.map(item => (
        <MenuItem key={item.route} {...item} />
      ))}
    </div>
  </div>
)
export default MenuDesktop
